import http from "../requestBase";

const API_BASE = "api/Language/Translations";

/**
 * Get the Translation for the given strings
 * @param {object} langobj - the lang Object where the Keys are the ids of the localizable string
 * @returns
 */
function getTranslationfor(langobj) {
  let langKeys = Object.keys(langobj);
  return http.post(API_BASE, langKeys);
}

const UseLang = {
  getTranslationfor,
};

export default UseLang;



// WEBPACK FOOTER //
// ./src/services/Language/index.js